import { CloseLightIcon, LeftArrow } from '@/shared/Icons'
import React, { useEffect, useRef } from 'react'

function VideoPopUp({ shorts, id, onClose }: { shorts: any; id: string; onClose: () => void }) {
  const sliderRef = useRef(null)

  useEffect(() => {
    if (sliderRef.current) {
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    }
  }, [id])

  return (
    <div className="fixed top-0 left-0 w-full h-full dark:bg-black/[7%] bg-white/[7%] backdrop-blur-lg z-50 md:pt-32 md:px-4 md:pb-4">
      <button
        onClick={() => onClose()}
        className="fixed top-3 left-3 md:left-auto md:top-[68px] md:right-[68px] p-1 md:p-0 w-6 h-6 md:w-[38px] md:h-[38px] flex items-center justify-center border-t-origin md:border-2 rounded-full text-t-origin"
      >
        <span className="hidden md:block dark:invert-0 invert-[1] dark:mix-blend-normal mix-blend-luminosity">
          <CloseLightIcon />
        </span>
        <span className="block md:hidden">
          <LeftArrow />
        </span>
      </button>
      <div className=" overflow-y-auto h-dvh md:h-[calc(100%--22px)]">
        <div className="max-w-full md:max-w-[900px] mx-auto" ref={sliderRef}>
          {shorts?.map((item: any) => {
            return (
              <div
                key={item?._id}
                id={item?._id}
                onClick={e => e.stopPropagation()}
                className="flex flex-col-reverse md:flex-row justify-between items-center gap-5 md:gap-[52px} pb-6 md:pb-8"
              >
                <div className="px-5 md:px-0 text-base md:text-32px leading-10 line-clamp-2 font-bold text-white origin">
                  {item?.sTitle}
                </div>
                <div className=" w-full md:w-[343px] flex-shrink-0">
                  <iframe
                    width="100%"
                    height="100%"
                    className=" h-[calc(100dvh-80px)] md:h-[614px] md:rounded-xl"
                    src={`https://${item?.oPlayer?.sEmbedUrl}`}
                    title={item?.sTitle}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  ></iframe>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default VideoPopUp
